export const DefaultPrivateOptions = {
    hostname: "realtime.pubq.io",
    secure: true,
    port: 443,
    path: "/",
};
